import AjaxUtil from '../../axios/axios';

/**
 * get course list for lms 
 */
export const getArticles = async (topic_id) => {
    try {
        return await AjaxUtil.sendRequest(`getliterature/${topic_id}`, {}, false, { method: 'get', showError: true, isProfile: false });
    } catch (error) {
        throw error;
    }
}


export const fetchUserCredits = async (agentId, topic_id) => {
    try {
        return await AjaxUtil.sendRequest(`/get/usercredits/${agentId}/${topic_id}`, {}, false, { method: 'get', showError: true, isProfile: false });
    } catch (error) {
        throw error;
    }
}

/**
 * get request id for literature search
 */
export const fetchRequestId = async (topic_id, ai_module_id) => {
    try {
        return await AjaxUtil.sendRequest(`literature/search/initiate?topic_id=${topic_id}&ai_module_id=${ai_module_id}`, {}, false, { method: 'post', showError: true, isProfile: false, isRagUrl : true });
    } catch (error) {
        throw error;
    }
}

export const updateLiteratureFeedback = async (data) => {
    try {
        return await AjaxUtil.sendRequest(`addfeedback`, data, false, { method: 'post', showError: true, isProfile: true });
    } catch (error) {
        throw error;
    }
}